import { CSSProperties, useRef, useState, useContext, useEffect } from 'react'
import { DataContext } from '../data/DataContext';
import { CheckBox, ModalMsgCtrl } from '../components'
import ReCAPTCHA from 'react-google-recaptcha';
import { useRecaptcha } from '../hook';
import { GetNewGuid } from '../data/Help'

import Modal from 'react-modal'

const Step4 = () => {

    const [openModal, setOpenModal] = useState(false);
    const { AutoEmisionCR, setAutoEmisionCR, ChangeHandler } = useContext(DataContext);
    const { capchaToken, recaptchaRef, handleRecaptcha } = useRecaptcha();
    let inpuReqtRef = useRef<HTMLInputElement>(null);



    const styleTitle: CSSProperties = {
        backgroundColor: '#C4C4C4',
        textAlign: 'center',
        color: '#4D4D4D'
    } as CSSProperties;

    const styleTextDetail: CSSProperties = {
        textAlign: 'justify',
        color: '#4D4D4D'
    } as CSSProperties;

    const styleModal = {
        overlay: { background: 'rgba(255, 255, 255, 0.85)' }
    }

    const OnChangeChk = (property: string, value: boolean) => setAutoEmisionCR({ ...AutoEmisionCR, [property]: value });


    const SendNotificationEvicertia = (e: any) => {    
        let result = document.querySelector("form") as HTMLFormElement;
        if (result.reportValidity() === false) return; 
        AutoEmisionCR.sendNotificationEvicertia(AutoEmisionCR);
    }

    useEffect(() => {
        inpuReqtRef.current?.setCustomValidity("");
        if (capchaToken === '' || capchaToken === null) inpuReqtRef.current?.setCustomValidity("Campo requerido");
    })



    return (
        <>

            <table style={{ border: '1px solid #e4e4e4', borderWidth: 'thin', borderSpacing: '0px' }}>
                <tr style={styleTitle}>
                    <td>DECLARACIONES DEL <br /> PROPUESTO ASEGURADO</td>
                </tr>
                <tr>
                    <td style={styleTextDetail}>
                        <p>
                            Declaro y acepto que los datos brindados anteriormente son exactos y verídicos.
                            Asimismo, declaro y acepto que cualquier omisión voluntaria declaración
                            falsa eximirá a SEGUROS LAFISE COSTA RICA S.A, del pago de reclamaciones,
                            de acuerdo con el Artículo 32 de la Ley Reguladora del Contrato de Seguros N' 8956.
                            Cualquier cambio o modificación de la información aquí suministrada,
                            deberá ser notificado a SEGUROS LAFISE COSTA RICA S.A.
                        </p>
                        <p>
                            Hago constar que he recibido conforme y previo al perfeccionamiento del contrato,
                            la información sobre el presente contrato de seguro, así como las Condiciones Generales del Seguro,
                            las cuales puedo revisar accediendo a las siguientes páginas web: Seguros Lafise: https://www.lafise.com/slcr/
                        </p>
                    </td>
                </tr>
                <tr style={styleTitle}>
                    <td>CONSENTIMIENTO <br /> INFORMADO</td>
                </tr>
                <tr>
                    <td style={styleTextDetail}>
                        <p>
                            De acuerdo con lo establecido en la Ley de Protección de la Persona frente al Tratamiento de sus Datos Personales (Ley 8368), le informamos lo siguiente:
                        </p>
                        <p>
                            La información brindada por usted como parte del proceso de contratación de un seguro con SEGUROS LAFISE, será almacenada en una base de datos de carácter personal nacional o internacional, con la finalidad de ofrecerte los servicios y coberturas adquiridos en el seguro. Adicionalmente, la información será uiizada en el ofrecimiento de productos y cualquier otro servicio brindado por SEGUROS LAFISE.
                        </p>
                        <p>
                            SEGUROS LAFISE COSTA RICA S.A, entidad con cédula jurídica 3-101-678807, será la destinataria dela información personal brindada por usted, la cual podrá ser consultada tanto por el personal de SEGUROS LAFISE, así como las personas con las que SEGUROS LAFISE mantenga algún tipo de relación comercial, y cuenten con autorización por parte de SEGUROS LAFSE, a quienes se les podrá transferir la información con los fines antes descritos. La información brindada por usted es facultativa, no obstante, en caso de oponerse, SEGUROS LAFISE se podría ver imposibilitado de brindarle algunos de los servicios contratados. Como titular de los datos personales, SEGUROS LAFISE le brinda el derecho de acceso, verificación, rectificación o eliminación de los mismos. Con pleno conocimiento de los señalado anteriormente, brindo el consentimiento para el tratamiento de mis datos personales.
                        </p>
                    </td>
                </tr>
                <tr style={styleTitle}>
                    <td>PROCESO DE ANÁLISIS (ACEPTACIÓN <br /> O RECHAZO) DE LA SOLICITUD</td>
                </tr>
                <tr>
                    <td style={styleTextDetail}>
                        <p>
                            La solicitud de seguro que cumpla con todos los requerimientos deberá ser aceptada o rechazada dentro de un plazo máximo de treinta (30) días naturales, contados a partir de la fecha de su recibo. Si SEGUROS LAFISE no se pronuncia dentro del plazo establecido, la solicitud de seguro se entenderá aceptada. En casos de complejidad excepcional, SEGUROS LAFISE deberá indicar al solicitante la fecha posterior en que se pronunciará, la cual no podrá exceder de dos (2) meses
                        </p>
                        <p>
                            <strong>
                                La documentación contractual y la nota técnica que integran este producto, están registrados ante la Superintendencia General de Seguros de conformidad con lo dispuesto por el artículo 29, inciso d) de la Ley Reguladora del Mercado de Seguros, Ley 8653, bajo el registro número GO1-01-A14-715, de fecha 08 de Junio de 2017.
                            </strong>
                        </p>
                    </td>
                </tr>
            </table>
            <CheckBox
                field='accepTerm'
                label='Acepto la Política de tratamiento de datos.'
                onChange={OnChangeChk}
                onClickLabel={() => setOpenModal(true)}
                value={AutoEmisionCR.accepTerm}

            />
            <div className='mt-20'>
                <ReCAPTCHA
                    ref={recaptchaRef}
                    onChange={handleRecaptcha}
                    sitekey={process.env.REACT_APP_RECAPTCHA_KEY}

                />
                <input ref={inpuReqtRef} type="radio" name={GetNewGuid()} className="sg-switch-validator" />

            </div>
            {/* <div className='mt-20 mb-20' style={{ display: 'flex', justifyContent: 'center' }}>
                <button className='btn-auto-cr  back-auto-cr' type="button" onClick={SendNotificationEvicertia}>Firma del asegurado</button>
            </div> */}

            <Modal isOpen={openModal} style={styleModal} className='modal'>
                <div className="mt20 mb-20" style={{ textAlign: 'justify', paddingLeft: '10%', paddingRight: '10%', paddingTop: '20px', paddingBottom: '20px', fontSize: '17px' }} >
                    <p style={{ color: '#4D4D4D' }}>
                        En cumplimiento con la <strong> Ley 8204 </strong> y la Política Conozca a su Cliente,
                        declaro que este formulario ha sido completado por mí y/o en mi presencia
                        y que la información provista en el mismo es fiel y verdadera.
                        Asimismo, declaro que los recursos por movilizar a través del <strong> Grupo Financiero Lafise </strong>
                        (en adelante G.F.L.) provienen de actividades lícitas.
                        La información de este formulario puede ser utilizada
                        por cualquiera de las empresas del G.F.L. para los fines respectivos
                    </p>
                </div>
                <div className="modal-footer">
                    <button className="modal-btn-close" style={{ background: '#008866' }} onClick={() => setOpenModal(false)}>Cerrar</button>
                </div>
            </Modal>
        </>
    )
}

export { Step4 }